/**
 * CLE-2883 — the "Exception is approved" button sits in the benefits panel's out-of-network banner, but the
 * eligibility request is built by `EligibilityButton` in the insurance section above it. The banner asks for
 * the re-run with this window event (the same pattern `triggerProfessionalCopay` already uses) and the
 * button for the matching side runs it, with `outOfNetworkExceptionApproved: true`.
 */
export const OUT_OF_NETWORK_EXCEPTION_EVENT = "approveOutOfNetworkException";

export interface IOutOfNetworkExceptionEventDetail {
  isSecondaryInsurance: boolean;
}

export const requestOutOfNetworkException = (isSecondaryInsurance: boolean) => {
  window.dispatchEvent(
    new CustomEvent<IOutOfNetworkExceptionEventDetail>(
      OUT_OF_NETWORK_EXCEPTION_EVENT,
      { detail: { isSecondaryInsurance } }
    )
  );
};
